module.exports = __webpack_public_path__ + "8ff78ef12eee1bfd52f2f64d195c392f.MP3";